import { StatusBadge } from '../StatusBadge';
import type { ProviderHealthT } from '../../api/voiceConfig';

// StatusBadge uses 'warn' (not 'warning') — see BadgeTone type
const TONE: Record<ProviderHealthT['status'], 'success' | 'warn' | 'danger' | 'info'> = {
  ok: 'success', degraded: 'warn', down: 'danger', idle: 'info',
};

export function ProviderStatusCard({ title, data }: { title: string; data: ProviderHealthT }) {
  return (
    <div className="vp-card" style={{ padding: 16 }}>
      <h3 style={{ margin: '0 0 8px', fontSize: 'var(--vp-text-md)' }}>{title}</h3>
      <p style={{ margin: '0 0 8px', fontSize: 'var(--vp-text-sm)' }}>
        <strong>{data.provider}</strong> · {data.model}
      </p>
      <p style={{ margin: '0 0 8px', fontSize: 'var(--vp-text-sm)', color: 'var(--vp-text-2)' }}>
        Chiave: <span>{data.api_key_present ? data.api_key_hint : 'non configurata'}</span>
      </p>
      <div style={{ marginBottom: 8 }}>
        <StatusBadge tone={TONE[data.status]}>{data.status}</StatusBadge>
      </div>
      {data.events_count === 0 ? (
        <p style={{ margin: 0, color: 'var(--vp-text-2)', fontSize: 'var(--vp-text-sm)' }}>
          Nessuna chiamata negli ultimi 60min
        </p>
      ) : (
        <ul style={{ margin: 0, paddingLeft: 16, fontSize: 'var(--vp-text-sm)' }}>
          <li>p50: {data.p50_ms} ms · p99: {data.p99_ms} ms</li>
          <li>error rate: {(data.error_rate * 100).toFixed(1)}% ({data.events_count} eventi)</li>
        </ul>
      )}
      {data.last_failure && (
        <div role="alert" style={{
          marginTop: 8, padding: 8,
          background: 'var(--vp-danger-soft, #FEE)',
          borderRadius: 6, fontSize: 'var(--vp-text-sm)',
        }}>
          <strong>{data.last_failure.error_class}</strong>: {data.last_failure.message}
          <div style={{ color: 'var(--vp-text-2)' }}>
            {new Date(data.last_failure.ts).toLocaleString('it-IT')}
          </div>
        </div>
      )}
    </div>
  );
}
